import { DatePicker } from '@3plearning/react-components';
import dayjs from 'dayjs';
import { localeCode } from './locale-helpers';

require('dayjs/locale/es-mx');

export default class UIHelper {
    static formatDateRange(selectedDate) {
        if (selectedDate.startDate === null || selectedDate.endDate === null) {
            return '';
        }

        const formattedDate = UIHelper.formatDate(selectedDate);

        const formattedStartDate = formattedDate.startDate;
        const formattedEndDate = formattedDate.endDate;
        const isLifetime = selectedDate.type === DatePicker.LIFETIME;

        return isLifetime
            ? `+Prior ${formattedStartDate} - ${formattedEndDate}`
            : `${formattedStartDate} - ${formattedEndDate}`;
    }

    static formatDate = (selectedDate) => {
        const formatString = 'DD MMMM YYYY';
        const locale = localeCode().toLowerCase();
        dayjs.locale(locale);
        const startDate = dayjs(selectedDate.startDate).format(formatString);
        const endDate = dayjs(selectedDate.endDate).format(formatString);
        return {
            startDate,
            endDate
        };
    };
}



// WEBPACK FOOTER //
// ./helpers/ui-helper.js